import { render, staticRenderFns } from "./CurrentStockAdjustTemp.vue?vue&type=template&id=37838d53&"
import script from "./CurrentStockAdjustTemp.vue?vue&type=script&lang=js&"
export * from "./CurrentStockAdjustTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports